import { BotIcon, Building2Icon, BuildingIcon, PhoneCallIcon, User2Icon } from 'lucide-react';

export const ADMIN_SUB_PAGES = [
  {
    title: 'Organizations',
    label: 'Organizations',
    description: 'All organizations in solea.',
    icon: Building2Icon,
    url: '/admin/orgs',
  },
  {
    title: 'Offices',
    label: 'Offices',
    description: 'All offices in solea.',
    icon: BuildingIcon,
    url: '/admin/offices',
  },
  {
    title: 'Employees',
    label: 'Employees',
    description: 'All employees in solea.',
    icon: User2Icon,
    url: '/admin/employees',
  },
  {
    title: 'Calls',
    label: 'Calls',
    description: 'All calls in solea.',
    icon: PhoneCallIcon,
    url: '/admin/calls',
  },
  {
    title: 'Agent',
    label: 'Agent',
    description: 'All agents in solea.',
    icon: BotIcon,
    url: '/admin/agent',
  },
];
